import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { GET_ADMIN_APPLICATION_FILE_CONFIG_URL } from '../../constants/apiUrls';
import { GET_ADMIN_APPLICATION_FILE_CONFIGS_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface AdminApplicationFileConfigsResponse {
  fileSizeLimit: number;
  fileNumLimit: number;
  uploadFileTypes: string[];
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: AdminApplicationFileConfigsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  applicationType: string;
}

export const useGetAdminApplicationFileConfigs = ({
  onSuccess,
  onError,
  applicationType,
}: Input) => {
  const getAdminApplicationFileConfigs = async () => {
    const res = await axiosClient.get<AdminApplicationFileConfigsResponse>(
      GET_ADMIN_APPLICATION_FILE_CONFIG_URL(applicationType)
    );
    return res.data;
  };

  return useCustomQuery(
    GET_ADMIN_APPLICATION_FILE_CONFIGS_QUERY_KEY,
    getAdminApplicationFileConfigs,
    {
      onSuccess,
      onError,
    }
  );
};
